import { render, staticRenderFns } from "./VentasPorTrimestre.vue?vue&type=template&id=ff111a0a"
import script from "./VentasPorTrimestre.vue?vue&type=script&lang=js"
export * from "./VentasPorTrimestre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports